import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import api from '@/lib/api';

const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_a3709e67-7648-4bcb-a123-219697b944ef/artifacts/aqwsfdgh_Martin_Aagaard_-_Kystlandskap_-_IMG_9313.jpg';

export default function InvitePage() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/invite-codes/validate', { code: code.trim() });
      
      if (response.data.valid) {
        toast.success('Valid invite code!');
        // Store the validated code and redirect to signup
        sessionStorage.setItem('validated_invite_code', code.trim().toUpperCase());
        navigate(`/signup?code=${code.trim().toUpperCase()}`);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid invite code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative" data-testid="invite-page">
      {/* Background */}
      <div
        className="absolute inset-0 bg-center bg-cover opacity-30"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-[var(--cream)]/80" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="p-6">
          <Link to="/" className="text-lg text-[var(--navy-800)] font-light tracking-widest">
            COASTWISE TRADE
          </Link>
        </header>

        {/* Form */}
        <div className="flex-1 flex items-center justify-center px-6">
          <div className="w-full max-w-sm">
            <h1 className="text-2xl font-semibold text-[var(--navy-800)] text-center mb-8">
              Enter Invite Code
            </h1>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  className="input-field text-center text-xl font-mono tracking-widest"
                  placeholder="XXXXXXXX"
                  maxLength={8}
                  required
                  data-testid="invite-code-input"
                />
              </div>
              <button
                type="submit"
                className="btn-big btn-big-primary flex items-center justify-center"
                disabled={loading || code.length < 1}
                data-testid="invite-submit-button"
              >
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Continue'}
              </button>
            </form>

            <p className="mt-6 text-center text-sm text-[var(--muted-foreground)]">
              Already have an account?{' '}
              <Link to="/login" className="text-[var(--navy-800)] font-medium hover:underline">
                Sign in
              </Link>
            </p>
            <p className="mt-2 text-center text-sm text-[var(--muted-foreground)]">
              <Link to="/enter" className="text-[var(--navy-800)] font-medium hover:underline">
                ← Back
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
